<p-button
  [icon]="preferences.soundNotificationsEnabled() ? 'pi pi-volume-up' : 'pi pi-volume-off'"
  [text]="true"
  [rounded]="true"
  [ariaLabel]="'shared.soundSettings.ariaLabel' | translate"
  [pTooltip]="'shared.soundSettings.tooltip' | translate"
  tooltipPosition="bottom"
  (onClick)="togglePanel($event)"
/>

<p-popover #panel [style]="{ width: '20rem' }">
  <div class="flex flex-col gap-3 px-1 py-1">
    <div class="flex items-center justify-between">
      <span class="font-semibold">{{ 'shared.soundSettings.title' | translate }}</span>
      <p-checkbox
        [binary]="true"
        [ngModel]="preferences.soundNotificationsEnabled()"
        (ngModelChange)="setEnabled($event)"
        [ariaLabel]="'shared.soundSettings.enableAriaLabel' | translate"
      />
    </div>

    <div>
      <div class="mb-1 flex items-center justify-between text-sm text-gray-500">
        <span>{{ 'shared.soundSettings.volume' | translate }}</span>
        <button type="button" class="text-blue-600 hover:underline" (click)="previewSound()">{{ 'shared.soundSettings.preview' | translate }}</button>
      </div>
      <p-slider
        [ngModel]="preferences.soundNotificationsVolume() * 100"
        (ngModelChange)="setVolume($event)"
        [disabled]="!preferences.soundNotificationsEnabled()"
      />
    </div>

    <div>
      <div class="mb-1 text-sm text-gray-500">{{ 'shared.soundSettings.playSoundFor' | translate }}</div>
      <div class="flex flex-col gap-1">
        @for (item of notificationTypes; track item.type) {
          <label class="flex items-center gap-2 text-sm">
            <p-checkbox
              [binary]="true"
              [ngModel]="!preferences.mutedSoundNotificationTypes().has(item.type)"
              (ngModelChange)="toggleType(item.type)"
              [disabled]="!preferences.soundNotificationsEnabled()"
            />
            {{ item.labelKey | translate }}
          </label>
        }
      </div>
    </div>
  </div>
</p-popover>
